import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import { html } from '@resn/gozer-core';
import config from '@resn/gozer-core/config';
import { getRoute } from 'utils/get-pages';
import Indicator from '../../indicator';

import getStore from 'core/store';
import { debounce } from 'underscore';
import { autobind } from 'core-decorators';
import { PAGE_DATA } from 'data/page-data';

const store = getStore();
const menuPages = [
    PAGE_DATA.XS1,
    PAGE_DATA.XP1,
    PAGE_DATA.OXEFIT,
    PAGE_DATA.OXELEAD,
    PAGE_DATA.OXELIFE,
    PAGE_DATA.SHOP,
];

class HeaderCenter extends Component {
    options = {};
    props = {
        page: () => store.state.route.page,
        rollover: false,
    };

    async onSetup() {
        await this.createLinks();
        await this.createIndicator();

        this.resize = debounce(this.resize, 100);
    }

    async createLinks() {
        this.linkXS1 = await new Link().setup({
            options: {
                appendTo: this.options.el,
                rollover: () => this.handleRollover('xs1'),
                rollout: this.handleRollout,
                label: 'XS1',
                route: 'xs1',
                navigateTo: this.options.navigateTo,
            },
            props: {
                active: () => this.props.page == 'xs1',
            },
        });

        this.linkXP1 = await new Link().setup({
            options: {
                appendTo: this.options.el,
                rollover: () => this.handleRollover('xp1'),
                rollout: this.handleRollout,
                label: 'XP1',
                route: 'xp1',
                navigateTo: this.options.navigateTo,
            },
            props: {
                active: () => this.props.page == 'xp1',
            },
        });

        this.linkSolutions = await new Link().setup({
            options: {
                appendTo: this.options.el,
                rollover: () => this.handleRollover('oxefit'),
                rollout: this.handleRollout,
                label: 'Entertainment',
                route: 'oxefit',
                navigateTo: this.options.navigateTo,
            },
            props: {
                active: () => this.props.page.includes('oxe'),
            },
        });

        this.linkShop = await new Link().setup({
            options: {
                appendTo: this.options.el,
                rollover: () => this.handleRollover('shop'),
                rollout: this.handleRollout,
                label: 'Shop',
                route: 'shop',
                navigateTo: this.options.navigateTo,
            },
            props: {
                active: () => this.props.page == 'shop',
            },
        });

        this.links = [this.linkXS1, this.linkXP1, this.linkSolutions, this.linkShop];
    }

    async createIndicator() {
        this.indicator = await new Indicator().setup({
            options: {
                appendTo: this.options.el,
            },
            props: {
                // visible: () => !!menuPages.find((page) => page.name === store.state.route.page),
                visible: () => !!menuPages.find((page) => page.name === store.state.route.page) || this.props.rollover,
            },
        });
    }

    @autobind
    handleRollover(val) {
        this.props.rollover = true;

        this.links.forEach((l) => {
            if (l.options.route === val) this.indicator.transformTo({ translate: l.props.x, width: l.props.w });
        });
    }

    @autobind
    handleRollout() {
        this.props.rollover = false;

        this.links.forEach((l) => {
            if (l.props.active) this.indicator.transformTo({ translate: l.props.x, width: l.props.w });
        });
    }

    setPage() {
        this.links.forEach((l) => {
            if (l.props.active) this.indicator.transformTo({ translate: l.props.x, width: l.props.w });
        });
    }

    @autobind
    resize() {
        this.links.forEach((l) => {
            const bbox = l.el.getBoundingClientRect();
            l.props.w = bbox.width;
            l.props.x = l.el.offsetLeft + bbox.width * 0.5;

            if (l.props.active) this.indicator.transformTo({ translate: l.props.x, width: l.props.w });
        });
    }
}

export default HeaderCenter;

@componentMixin(DomComponentMixin)
class Link extends Component {
    options = {
        rollover: () => {},
        rollout: () => {},
        template: ({ props, options }) => {
            return html`
                <li
                    class="header__link"
                    ?active=${props.active}
                    @click=${(e) => {
                        e.preventDefault();
                        options.navigateTo(getRoute(options.route));
                    }}
                    @pointerenter=${options.rollover}
                    @pointerleave=${options.rollout}
                >
                    <span>${options.label}</span>
                    <!-- <span class="ref">${options.label}</span> -->
                    <!-- <span class="on">${options.label}</span> -->
                </li>
            `;
        },
    };

    props = {};

    async onSetup() {}
}
